import { POI_TYPES } from '../modules/roadscope/constants/poiTypes';

export const generateSurveyId = () => {
  // Format: SV-XXXXXXXX-XXXXXX (where X is alphanumeric)
  const generateRandomPart = (length) => {
    const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    return Array.from(
      { length },
      () => chars[Math.floor(Math.random() * chars.length)]
    ).join('');
  };

  return `SV-${generateRandomPart(8)}-${generateRandomPart(6)}`;
};

// Survey type prefixes
export const SURVEY_TYPES = {
  HIGH_POLE: 'HP',
  QUICK: 'QK',
  ADVANCED: 'AD',
  BOOK: 'BK',
  MAP: 'MP'
};

export const generatePOIId = (surveyType, poiType, routeNumber, sequence) => {
  // Get POI type prefix (2 characters)
  const typePrefix = poiType && POI_TYPES[poiType]?.prefix || 'XXX';
  
  // Format route number (2 digits)
  const route = `R${String(routeNumber || 0).padStart(2, '0')}`;
  
  // Format sequence (6 digits)
  const seq = String(sequence || 0).padStart(6, '0');
  
  // Final format: ST-POI-RXX-XXXXX
  return `${surveyType}-${typePrefix}-${route}-${seq}`;
};